<p-blockui [blocked]="isLoading()">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<form [formGroup]="filterForm" 
  class="w-full grid grid-cols-12 justify-end gap-4">

  <div class="col-span-12 md:col-span-6 lg:col-span-4 2xl:col-start-4 2xl:col-span-4">
    <p-multiSelect
      fluid
      id="selectedBusinesses"
      formControlName="selectedBusinesses"
      [options]="getBusinessOptions()"
      placeholder="Filtrar por empresa"
      [showToggleAll]="false"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      filterBy="label"
    >
      <ng-template #selectedItem let-selectedOption>
        @if (selectedOption) {
          <app-business-logo
            [logoUrl]="selectedOption.logoUrl"
            [name]="selectedOption.label"
            logoSize="sm">
          </app-business-logo>
        }
      </ng-template>
      <ng-template let-business #item>
        <app-business-logo
          [logoUrl]="business.logoUrl"
          [name]="business.label"
          logoSize="sm">
        </app-business-logo>
      </ng-template>
    </p-multiSelect>
  </div>
  
  <div class="col-span-12 md:col-span-6 lg:col-span-4 2xl:col-span-3">
    <input
      pInputText
      id="searchText"
      formControlName="searchText"
      placeholder="Buscar"
      fluid
    />
  </div>

  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-1">
    <p-button
      label="Filtrar"
      icon="pi pi-search"
      (onClick)="onSearch()"
      [loading]="isLoading()"
      type="button"
      fluid
    />
  </div>

  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-1">
    <p-button
      label="Limpiar"
      icon="pi pi-times"
      severity="secondary"
      (onClick)="onClearFilters()"
      [loading]="isLoading()"
      type="button"
      fluid
    />
  </div>
</form>